var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytes32, FctValue, isVariable } from '../../../../Fct/generics';
import { getAllCurrencies } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { ROUTER_V2_ADDRESS } from '../../../../Fct/plugins/uniswap/constants';
import { getIsNative } from '../../../../Fct/plugins/uniswap/helpers/getToken';
import { fctUniswapContracts, liquidity_method } from '../constants';
import { getAddLiquidityGasLimit } from './getGasLimit';
import { Uniswap } from '../../../../Fct/plugins/uniswap/helpers/Uniswap';
import BigNumber from 'js-big-decimal';
import { FaWater } from 'react-icons/fa';
var method = 'addLiquidity_noMinProtection';
export var SimpleAddLiquidity = createPlugin({
    protocol: 'UNISWAP',
    type: 'LIBRARY',
    method: method,
    name: method,
    description: 'Add liquidity on Uniswap',
    supportedContracts: fctUniswapContracts,
    toEns: '@lib:uniswap_v2',
    initParams: {
        methodParams: {
            method: liquidity_method.addLiquidity,
        },
    },
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'uniswap_router' }),
                methodParams: {
                    method: new FctBytes32({
                        messageType: 'string',
                        options: Object.keys(liquidity_method).map(function (key) {
                            var methodKey = key;
                            return { name: key, value: liquidity_method[methodKey] };
                        }),
                    }),
                    tokenA: new FctAddress({ destination: 'erc20', options: getAllCurrencies({ chainId: chainId }), isPreview: true }),
                    tokenB: new FctAddress({ destination: 'erc20', options: getAllCurrencies({ chainId: chainId }), isPreview: true }),
                    amountADesired: new FctValue({ destination: 'wei_amount', isPreview: true }),
                    amountBDesired: new FctValue({ destination: 'wei_amount', isPreview: true, icon: FaWater }),
                },
            },
            output: {
                amountA: new FctValue({ destination: 'wei_amount', innerIndex: 0 }),
                amountB: new FctValue({ destination: 'wei_amount', innerIndex: 1 }),
                liquidity: new FctValue({ destination: 'wei_amount', innerIndex: 2 }),
            },
        });
    },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, chainId = _a.chainId, provider = _a.provider, account = _a.account, setMethod = _a.setMethod;
        var helper = new Uniswap({ chainId: chainId, account: account, provider: provider });
        var prevAmountADesiredValue = isVariable(input.methodParams.amountADesired.value)
            ? input.methodParams.amountADesired.estimatedValue
            : input.methodParams.amountADesired.value;
        var prevAmountBDesiredValue = isVariable(input.methodParams.amountBDesired.value)
            ? input.methodParams.amountBDesired.estimatedValue
            : input.methodParams.amountBDesired.value;
        var getValues = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, tokenA, tokenB, amountADesired, amountBDesired, tokenAValue, tokenBValue, amountADesiredValue, amountBDesiredValue, rates, isCurrencyANative, method, isCurrencyBNative, reserves, amountBValue, amountAValue;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = input.methodParams, tokenA = _a.tokenA, tokenB = _a.tokenB, amountADesired = _a.amountADesired, amountBDesired = _a.amountBDesired;
                        tokenAValue = tokenA.value;
                        tokenBValue = tokenB.value;
                        if (typeof tokenAValue !== 'string')
                            return [2 /*return*/, { params: {}, error: undefined }];
                        if (typeof tokenBValue !== 'string')
                            return [2 /*return*/, { params: {}, error: undefined }];
                        amountADesiredValue = isVariable(amountADesired.value)
                            ? amountADesired.estimatedValue
                            : amountADesired.value;
                        amountBDesiredValue = isVariable(amountBDesired.value)
                            ? amountBDesired.estimatedValue
                            : amountBDesired.value;
                        return [4 /*yield*/, helper.getToken1LiquidityRate({
                                token0: tokenAValue,
                                token1: tokenBValue,
                            })];
                    case 1:
                        rates = _b.sent();
                        isCurrencyANative = false;
                        method = liquidity_method.addLiquidity;
                        if (typeof tokenA.value === 'string') {
                            isCurrencyANative = getIsNative(tokenA.value);
                            if (isCurrencyANative) {
                                method = liquidity_method.addLiquidityEthToken;
                            }
                        }
                        isCurrencyBNative = false;
                        if (typeof tokenB.value === 'string') {
                            isCurrencyBNative = getIsNative(tokenB.value);
                            if (isCurrencyBNative && setMethod) {
                                method = liquidity_method.addLiquidityTokenEth;
                            }
                        }
                        if (!rates)
                            return [2 /*return*/, { params: { methodParams: { method: method } }, error: 'no rates' }];
                        return [4 /*yield*/, helper.getReserves({
                                token0: tokenAValue,
                                token1: tokenBValue,
                            })];
                    case 2:
                        reserves = _b.sent();
                        if (!reserves)
                            return [2 /*return*/, { params: { methodParams: { method: method } }, error: 'no reserves' }];
                        if (!isVariable(amountBDesired.value) &&
                            typeof amountADesiredValue === 'string' &&
                            prevAmountADesiredValue !== amountADesiredValue) {
                            prevAmountADesiredValue = amountADesiredValue;
                            amountBValue = new BigNumber(amountADesiredValue).multiply(new BigNumber(rates)).floor().getValue();
                            prevAmountBDesiredValue = amountBValue;
                            return [2 /*return*/, {
                                    params: {
                                        methodParams: { amountBDesired: amountBValue, method: method },
                                    },
                                    error: undefined,
                                }];
                        }
                        if (!isVariable(amountADesired.value) &&
                            typeof amountBDesiredValue === 'string' &&
                            prevAmountBDesiredValue !== amountBDesiredValue) {
                            prevAmountBDesiredValue = amountBDesiredValue;
                            amountAValue = new BigNumber(amountBDesiredValue)
                                .divide(new BigNumber(rates), amountBDesired.decimals || 18)
                                .floor()
                                .getValue();
                            prevAmountADesiredValue = amountAValue;
                            return [2 /*return*/, {
                                    params: {
                                        methodParams: { amountADesired: amountAValue, method: method },
                                    },
                                    error: undefined,
                                }];
                        }
                        return [2 /*return*/, { params: { methodParams: { method: method } }, error: undefined }];
                }
            });
        }); };
        var getDepParams = function () {
            var _a = input.methodParams, amountADesired = _a.amountADesired, amountBDesired = _a.amountBDesired;
            var defaultDeps = ['methodParams.tokenA', 'methodParams.tokenB'];
            if (amountADesired.value !== prevAmountADesiredValue) {
                defaultDeps.push('methodParams.amountADesired');
                return defaultDeps;
            }
            if (amountBDesired.value !== prevAmountBDesiredValue) {
                defaultDeps.push('methodParams.amountBDesired');
                return defaultDeps;
            }
            return defaultDeps.concat(['methodParams.amountADesired', 'methodParams.amountBDesired']);
        };
        return {
            get: getValues,
            depParamKeys: getDepParams,
        };
    },
    getParamsOnCreate: function (_a) {
        var chainId = _a.chainId, params = _a.params, isEstimation = _a.isEstimation;
        return __awaiter(void 0, void 0, void 0, function () {
            var _b, amountADesired, amountBDesired, tokenA, tokenB, requiredParamsExact, requiredParamsExact_1, requiredParamsExact_1_1, param, isCurrencyANative, isCurrencyBNative, gasLimit;
            var e_1, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = params.methodParams, amountADesired = _b.amountADesired, amountBDesired = _b.amountBDesired, tokenA = _b.tokenA, tokenB = _b.tokenB;
                        requiredParamsExact = [
                            { value: amountADesired.value, key: 'amountADesired' },
                            { value: amountBDesired.value, key: 'amountBDesired' },
                        ];
                        try {
                            for (requiredParamsExact_1 = __values(requiredParamsExact), requiredParamsExact_1_1 = requiredParamsExact_1.next(); !requiredParamsExact_1_1.done; requiredParamsExact_1_1 = requiredParamsExact_1.next()) {
                                param = requiredParamsExact_1_1.value;
                                if (!param.value) {
                                    console.error("wrong param ".concat(param.key, ": ").concat(param.value));
                                    return [2 /*return*/];
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (requiredParamsExact_1_1 && !requiredParamsExact_1_1.done && (_c = requiredParamsExact_1.return)) _c.call(requiredParamsExact_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        isCurrencyANative = false;
                        if (typeof tokenA.value === 'string') {
                            isCurrencyANative = getIsNative(tokenA.value);
                            if (isCurrencyANative) {
                                params.methodParams.method.set({ value: liquidity_method.addLiquidityEthToken });
                                // tokenA.set({ value: { type: 'constants', id: 'addressZero' } })
                            }
                        }
                        isCurrencyBNative = false;
                        if (typeof tokenB.value === 'string') {
                            isCurrencyBNative = getIsNative(tokenB.value);
                            if (isCurrencyBNative) {
                                params.methodParams.method.set({ value: liquidity_method.addLiquidityTokenEth });
                                // tokenB.set({ value: { type: 'constants', id: 'addressZero' } })
                            }
                        }
                        if (amountADesired.isVariable && !amountBDesired.isVariable) {
                            amountBDesired.set({ value: { type: 'constants', id: 'maxUint' } });
                        }
                        if (!amountADesired.isVariable && amountBDesired.isVariable) {
                            amountADesired.set({ value: { type: 'constants', id: 'maxUint' } });
                        }
                        if (!params.methodParams.method.value) {
                            params.methodParams.method.set({ value: liquidity_method.addLiquidity });
                        }
                        return [4 /*yield*/, getAddLiquidityGasLimit({
                                tokenA: tokenA.value,
                                tokenB: tokenB.value,
                                chainId: chainId,
                            })];
                    case 1:
                        gasLimit = _d.sent();
                        return [2 /*return*/, {
                                params: params,
                                method: method,
                                gasLimit: gasLimit,
                            }];
                }
            });
        });
    },
    requiredApprovals: function (params, chainId, _walletAddress, _vaultAddress, _provider, _method, isEstimation) {
        var amountAParam = params === null || params === void 0 ? void 0 : params.methodParams.amountADesired;
        var getAmountA = function () {
            if (isEstimation) {
                if (isVariable(amountAParam.value)) {
                    return amountAParam.estimatedValue;
                }
            }
            return amountAParam.value;
        };
        var amountBParam = params === null || params === void 0 ? void 0 : params.methodParams.amountBDesired;
        var getAmountB = function () {
            if (isEstimation) {
                if (isVariable(amountBParam.value)) {
                    return amountBParam.estimatedValue;
                }
            }
            return amountBParam.value;
        };
        return [
            {
                to: params.methodParams.tokenA.value,
                params: { spender: ROUTER_V2_ADDRESS[chainId], amount: getAmountA() },
                method: 'approve',
                protocol: 'ERC20',
            },
            {
                to: params.methodParams.tokenB.value,
                params: { spender: ROUTER_V2_ADDRESS[chainId], amount: getAmountB() },
                method: 'approve',
                protocol: 'ERC20',
            },
        ].filter(function (item) {
            return typeof item.to === 'string' ? !getIsNative(item.to) : true;
        });
    },
});
